export const THANKS_MODAL_SUCCESS = ({ name, clientType }) => `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/check_circle.png">
    <span class="thanks-name">Gracias ${name}</span>
    <p class="thanks-message">
    ${
      clientType
        ? 'Tu agente te llamará lo antes posible.'
        : 'Uno de nuestros agentes te contactará lo antes posible.'
    }
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">cerrar</button>
</div>
`

export const THANKS_MODAL_SUCCESS_EN = ({ name, clientType }) => `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/check_circle.png">
    <span class="thanks-name">Thank you ${name}</span>
    <p class="thanks-message">
    ${
      clientType
        ? 'Your agent will call you as soon as possible.'
        : 'One of our agents will contact you as soon as possible.'
    }
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">close</button>
</div>
`
export const THANKS_MODAL_SUCCESS_DE = ({ name, clientType }) => `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/check_circle.png">
    <span class="thanks-name">Danke ${name}</span>
    <p class="thanks-message">
    ${
      clientType
        ? 'Ihr Agent wird Sie so schnell wie möglich anrufen.'
        : 'Einer unserer Agenten wird sich so schnell wie möglich mit Ihnen in Verbindung setzen'
    }
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">schließen</button>
</div>
`
export const THANKS_MODAL_SUCCESS_FR = ({ name, clientType }) => `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/check_circle.png">
    <span class="thanks-name">Merci ${name}</span>
    <p class="thanks-message">
    ${
      clientType
        ? 'Votre agent vous appellera dans les plus brefs délais'
        : 'Un de nos agents vous contactera dans les plus brefs délais'
    }
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">Fermer</button>
</div>
`

export const THANKS_MODAL_ERROR = `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/error.png">
    <span class="thanks-name">Ha ocurrido un error</span>
    <p class="thanks-message">
    En estos momentos no podemos atenderle. Inténtelo de nuevo más tarde.
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">cerrar</button>
</div>
`

export const THANKS_MODAL_ERROR_EN = `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/error.png">
    <span class="thanks-name">An error has occurred</span>
    <p class="thanks-message">
    At this time we cannot assist you. Try it again later.
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">close</button>
</div>
`
export const THANKS_MODAL_ERROR_DE = `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/error.png">
    <span class="thanks-name">Ein Fehler ist aufgetreten</span>
    <p class="thanks-message">
    Derzeit können wir Ihnen nicht weiterhelfen. Versuchen Sie es später noch einmal.
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">schließen</button>
</div>
`
export const THANKS_MODAL_ERROR_FR = `
<div id="dmv-content" class="dmv-content dmv-content-thanks fade">
    <img class="thanks-svg" src="https://t.womtp.com/slider/c/allianz/src/img/error.png">
    <span class="thanks-name">Une erreur est survenue</span>
    <p class="thanks-message">
    Nous ne pouvons pas vous aider pour le moment. Réessayez plus tard.
    </p>
    <button onclick="DFI.ModalView.close()" class="thanks-btn-close">fermer</button>
</div>
`

export const THANKS_MODAL_LOADER = `
<div class="fade custom-budget__loader">
    <span class="loader"></span>
    <p class="thanks-message">Enviando...</p>
</div>
`
